import { EnrollApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';

function usePatchStatus() {
  const queryClient = useQueryClient();
  return useAuthMutation(EnrollApi.patchStatus, {
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [KEY],
      });
    },
  });
}

export default usePatchStatus;
